import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DceSharedRoutingModule } from './dce-shared-routing.module';
import { ShowErrorsComponent } from './show-errors/show-errors.component';
import { EmailInputComponent } from './email-input/email-input.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { BtnLoaderDirective } from '../dce-directives/btn-loader.directive';
import { TogglerComponent } from './toggler/toggler.component';
import { DatatableSearchComponent } from './datatable-search/datatable-search.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdvanceInputComponent } from './advance-input/advance-input.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonClickDirective } from '../dce-directives/button-click.directive';
import { TogglePasswordComponent } from './toggle-password/toggle-password.component';
import { NzRoleDirective } from '../dce-directives/nz-role.directive';
import { SideContainerComponent } from './side-container/side-container.component';
import { TableWidgetComponent } from './table-widget/table-widget.component';
import { DateFormatPipe } from '../pipes/date-format.pipe'

const components =[
  ShowErrorsComponent,
  EmailInputComponent,
  ConfirmationModalComponent,
  BtnLoaderDirective,
  TogglerComponent,
  DatatableSearchComponent,
  AdvanceInputComponent,
  UploadDocumentComponent,
  ButtonClickDirective,
  TogglePasswordComponent,
  NzRoleDirective,
  SideContainerComponent,
  TableWidgetComponent,
  DateFormatPipe
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    DceSharedRoutingModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    NgbModule
  ],
  exports: [
    components,
    ]
})
export class DceSharedModule { }
